// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* index.css */
.cdx-tool[data-tool="aiTextTool"] .cdx-toolbox__icon {
  font-size: 18px;
  font-weight: bold;
  color: #007bff; /* Customize the color */
  text-align: center;
}

/* Loading spinner */
.cdx-ai-text-loader {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid rgba(128, 128, 128, 0.3);
  border-radius: 50%;
  border-top-color: #808080;
  animation: spin 0.8s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Button styles - Arrow button */
.cdx-ai-text-button {
  padding: 0;
  background: none;
  color: #000;
  border: none;
  cursor: pointer;
  font-size: 18px;
  transition: opacity 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cdx-ai-text-button:hover:not(:disabled) {
  opacity: 0.7;
}

.cdx-ai-text-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.cdx-ai-text-button-content {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

/* Input wrapper */
.cdx-ai-text-input {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 40px;
  padding: 0;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc,EAAE,wBAAwB;EACxC,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,iCAAiC;AACjC;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd","sourcesContent":["/* index.css */\r\n.cdx-tool[data-tool=\"aiTextTool\"] .cdx-toolbox__icon {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  color: #007bff; /* Customize the color */\r\n  text-align: center;\r\n}\r\n\r\n/* Loading spinner */\r\n.cdx-ai-text-loader {\r\n  display: inline-block;\r\n  width: 12px;\r\n  height: 12px;\r\n  border: 2px solid rgba(128, 128, 128, 0.3);\r\n  border-radius: 50%;\r\n  border-top-color: #808080;\r\n  animation: spin 0.8s ease-in-out infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n/* Button styles - Arrow button */\r\n.cdx-ai-text-button {\r\n  padding: 0;\r\n  background: none;\r\n  color: #000;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  transition: opacity 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.cdx-ai-text-button:hover:not(:disabled) {\r\n  opacity: 0.7;\r\n}\r\n\r\n.cdx-ai-text-button:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\n\r\n.cdx-ai-text-button-content {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  justify-content: center;\r\n}\r\n\r\n/* Input wrapper */\r\n.cdx-ai-text-input {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  min-height: 40px;\r\n  padding: 0;\r\n  border: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
